import React from 'react'
import {PopularMovieList} from '~/components'
import {Home} from '~/pages/home'

export const Popular = () => (
  <Home>
    <PopularMovieList />
  </Home>
)
